import { Component, inject, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatIconModule } from '@angular/material/icon';
import { COMPANY_EXPORT_COLUMN_GROUPS, COMPANY_EXPORT_COLUMNS, ExportColumnDef } from '../export-columns';

interface DialogColumn extends ExportColumnDef {
  selected: boolean;
}

@Component({
  selector: 'app-export-columns-dialog',
  standalone: true,
  imports: [CommonModule, FormsModule, MatDialogModule, MatButtonModule, MatCheckboxModule, MatIconModule],
  templateUrl: './export-columns-dialog.component.html',
  styleUrl: './export-columns-dialog.component.scss'
})
export class ExportColumnsDialogComponent implements OnInit {
  private dialogRef = inject(MatDialogRef<ExportColumnsDialogComponent, string[] | null>);

  readonly groups = COMPANY_EXPORT_COLUMN_GROUPS;
  columns: DialogColumn[] = [];

  ngOnInit(): void {
    this.columns = COMPANY_EXPORT_COLUMNS.map(c => ({ ...c, selected: c.defaultSelected }));
  }

  columnsInGroup(group: string): DialogColumn[] {
    return this.columns.filter(c => c.group === group);
  }

  isGroupAllSelected(group: string): boolean {
    const cols = this.columnsInGroup(group);
    return cols.length > 0 && cols.every(c => c.selected);
  }

  isGroupAnySelected(group: string): boolean {
    return this.columnsInGroup(group).some(c => c.selected);
  }

  toggleGroup(group: string, selected: boolean): void {
    for (const c of this.columns) {
      if (c.group === group) c.selected = selected;
    }
  }

  selectAll(): void { this.columns.forEach(c => c.selected = true); }
  selectNone(): void { this.columns.forEach(c => c.selected = false); }
  selectDefaults(): void { this.columns.forEach(c => c.selected = c.defaultSelected); }

  get selectedCount(): number {
    return this.columns.filter(c => c.selected).length;
  }

  cancel(): void { this.dialogRef.close(null); }

  confirm(): void {
    const ids = this.columns.filter(c => c.selected).map(c => c.id);
    this.dialogRef.close(ids);
  }
}
